import { getDepartmentsByCodeAndJourneyCode } from "../../../../service/DepartmentService"
import { useQuery } from "react-query"

function useGetDepartments(tunnelData, values, countryCodeFromLanguage, countryCode, languageTag) {
  return useQuery({
    queryKey: ["query-departments", values?.identity?.birthCountry?.value, languageTag],
    queryFn: () =>
      getDepartmentsByCodeAndJourneyCode(tunnelData, {
        countryCodeFromLanguage,
        countryCode,
        languageTag
      }),
    refetchOnWindowFocus: false,
    enabled: !!values?.identity?.birthCountry?.value
  })
}

export default useGetDepartments
